module.exports = __webpack_public_path__ + "static/media/passive_index_funds.1d2f561d.svg";